import React from "react";
import { Box, Typography } from "@mui/material";
import GavelIcon from "@mui/icons-material/Gavel";
import {
  CONTRACTING_TYPE_BID,
  CONTRACTING_TYPE_FIXED,
} from "../util/contractingType";

const OPTIONS = [
  {
    value: CONTRACTING_TYPE_FIXED,
    title: "Preço fixo",
    subtitle: "Publicar com valor definido",
    message: "Informe o valor que será oferecido ao motorista ou transportadora.",
  },
  {
    value: CONTRACTING_TYPE_BID,
    title: "BID aberto a lance",
    subtitle: "Receber lances dos transportadores",
    message: "Transportadoras e motoristas poderão enviar propostas para esta carga.",
  },
];

function OptionIcon({ value, selected }) {
  if (value === CONTRACTING_TYPE_BID) {
    return (
      <Box
        aria-hidden
        sx={{
          alignItems: "center",
          border: selected ? "2px solid #FF3100" : "2px solid #D7DEE7",
          borderRadius: "50%",
          display: "flex",
          flexShrink: 0,
          height: 22,
          justifyContent: "center",
          width: 22,
        }}
      >
        <Box
          sx={{
            backgroundColor: selected ? "#FF3100" : "transparent",
            borderRadius: "50%",
            height: 10,
            width: 10,
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      aria-hidden
      sx={{
        alignItems: "center",
        backgroundColor: selected ? "rgba(255, 49, 0, 0.10)" : "#EEF2F6",
        borderRadius: "10px",
        color: selected ? "#FF3100" : "#012443",
        display: "flex",
        flexShrink: 0,
        height: 40,
        justifyContent: "center",
        width: 40,
      }}
    >
      <GavelIcon fontSize="small" />
    </Box>
  );
}

export default function FreightPublicationTypeCard({
  value,
  onChange,
  disabled = false,
  required = true,
}) {
  const selectedOption = OPTIONS.find((option) => option.value === value);

  return (
    <Box
      id="contractingType"
      className="form-signin mx-auto mb-4 mb-lg-6"
      sx={{
        background: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
        px: 2.5,
        py: 2.2,
      }}
    >
      <Typography
        component="label"
        sx={{
          color: "#012443",
          display: "block",
          fontSize: "0.92rem",
          fontWeight: 700,
          mb: 1.4,
        }}
      >
        Tipo de publicação
        {required ? (
          <>
            {" "}
            <span style={{ color: "#ff3100" }}>*</span>
          </>
        ) : null}
      </Typography>

      <Box
        role="radiogroup"
        aria-label="Tipo de publicação"
        sx={{
          display: "grid",
          gap: 1.5,
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        }}
      >
        {OPTIONS.map((option) => {
          const selected = value === option.value;
          const isBid = option.value === CONTRACTING_TYPE_BID;

          return (
            <Box
              key={option.value}
              role="radio"
              aria-checked={selected}
              tabIndex={disabled ? -1 : 0}
              onClick={() => {
                if (!disabled) onChange(option.value);
              }}
              onKeyDown={(event) => {
                if (disabled) return;
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onChange(option.value);
                }
              }}
              sx={{
                alignItems: "center",
                backgroundColor: selected
                  ? isBid
                    ? "rgba(255, 49, 0, 0.04)"
                    : "#F8FAFC"
                  : "#F8FAFC",
                border: selected
                  ? "1.5px solid #FF3100"
                  : "1.5px solid rgba(1, 36, 67, 0.12)",
                borderRadius: "14px",
                boxShadow: selected
                  ? "0 0 0 3px rgba(255, 49, 0, 0.08)"
                  : "none",
                cursor: disabled ? "default" : "pointer",
                display: "flex",
                gap: 1.5,
                minHeight: 84,
                opacity: disabled ? 0.72 : 1,
                outline: "none",
                px: 2,
                py: 1.6,
                transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                "&:hover": disabled
                  ? undefined
                  : {
                      borderColor: selected ? "#FF3100" : "rgba(1, 36, 67, 0.28)",
                    },
              }}
            >
              <OptionIcon value={option.value} selected={selected} />
              <Box>
                <Typography
                  sx={{
                    color: selected ? "#FF3100" : "#012443",
                    fontSize: "0.98rem",
                    fontWeight: 700,
                    lineHeight: 1.25,
                  }}
                >
                  {option.title}
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(1, 36, 67, 0.62)",
                    fontSize: "0.82rem",
                    fontWeight: 500,
                    lineHeight: 1.3,
                    mt: 0.35,
                  }}
                >
                  {option.subtitle}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>

      {selectedOption ? (
        <Typography
          sx={{
            color: "rgba(1, 36, 67, 0.72)",
            fontSize: "0.86rem",
            mt: 1.5,
          }}
        >
          {selectedOption.message}
        </Typography>
      ) : null}
    </Box>
  );
}
